import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { __ } from '@wordpress/i18n';
import { isNil } from 'ramda';

// tools
import renderHtmlContent from '../../../../helpers/renderHtmlContent';
import uniqid from '../../../../helpers/uniqid';

// components
import ArchiveDocument from '../ArchiveDocument';
import { DataTable } from 'primereact/datatable';
import translationStrings from '../../../../translationStringsForComponents';
import { Column } from 'primereact/column';
import ProperBandoLabel from '../../../../components/ProperBandoLabel';
import { Link } from 'react-router-dom';
import { FilterMatchMode, FilterOperator } from 'primereact/api';

const ListOfFilesToEvaluate = ({ files, updateFn, shouldDisableFieldFn, name, applicationId }) => {
    const [filters, setFilters] = useState(null);
    const [loading, setLoading] = useState(false);

    const getFormattedData = (data) => {
        return [...(data || [])].map((d) => {
            if (d?.fileDetail[0]?.createdDate) {
                d.fileDetail[0].createdDate = new Date(d.fileDetail[0].createdDate);
            }

            return d;
        });
    };

    const formatDate = (value) => {
        return value.toLocaleDateString('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const docNameTemplate = (rowData) => {
        return renderHtmlContent(rowData.label);
    }

    const createdDateTemplate = (rowData) => {
        return formatDate(rowData?.fileDetail[0]?.createdDate);
    }

    const expirationDateTemplate = (rowData) => {
        return 'N/A';
    }

    const statusBodyTemplate = (rowData) => {
        return <ProperBandoLabel status={rowData.status}/>;
    };

    const actionsBodyTemplate = (rowData, row) => {
        return <div className="appPageSection__tableActions noWrap lessGap">
            <Button icon="pi pi-eye" rounded
                    onClick={() => {
                        window.open(rowData.fileDetail[0].filePath, '_blank').focus()
                    }}
                    outlined severity="info"
                    aria-label={__('Mostra', 'htr')}/>
            <Button icon="pi pi-thumbs-up" rounded outlined
                    disabled={shouldDisableFieldFn(name)}
                    severity={!isNil(rowData.valid) && rowData.valid ? 'success' : 'secondary'}
                    onClick={() => updateFn(
                        true,
                        [name, row.rowIndex, 'valid']
                    )}
                    aria-label={__('Su', 'htr')}/>
            <Button icon="pi pi-thumbs-down" rounded outlined
                    disabled={shouldDisableFieldFn(name)}
                    severity={!isNil(rowData.valid) && !rowData.valid ? 'danger' : 'secondary'}
                    onClick={() => updateFn(
                        false,
                        [name, row.rowIndex, 'valid']
                    )}
                    aria-label={__('Giu', 'htr')}/>
        </div>
    }

    const formattedFiles = getFormattedData(files);

    return(
        <div className="appPageSection__table">
            <DataTable value={formattedFiles} paginator showGridlines rows={5} loading={loading} dataKey="id"
                       stripedRows
                       removableSort
                       emptyMessage={translationStrings.emptyMessage}>
                <Column field="label" header={__('Nome Documento', 'htr')}
                        body={docNameTemplate}
                        style={{ minWidth: '8rem' }}/>
                <Column header={__('Caricamento', 'htr')}
                        body={createdDateTemplate}
                        style={{ minWidth: '8rem' }}/>
                <Column header={__('Data Scadenza', 'htr')}
                        body={expirationDateTemplate}
                        style={{ minWidth: '8rem' }}/>
                <Column header={__('Stato', 'htr')}
                        style={{ minWidth: '7rem' }} body={statusBodyTemplate} />
                <Column header={__('Azioni', 'htr')}
                        body={actionsBodyTemplate}/>
            </DataTable>
        </div>
    )
    /*return (
        <ol className="appPageSection__list">
            {files
                ? files.map((o, i) => <li key={`${o.id}_${uniqid('f')}`} className="appPageSection__listItem">
                <div className="appPageSection__listItemRow">
                    <div>{renderHtmlContent(o.label)}</div>
                    <div className="appPageSection__iconActions">
                        {o.fileDetail && o.fileDetail.length === 1
                            ? <>
                            <Button icon="pi pi-eye" rounded
                                      onClick={() => {
                                          window.open(o.fileDetail[0].filePath, '_blank').focus()
                                      }}
                                      outlined severity="info"
                                      aria-label={__('Mostra', 'htr')}/>
                                <ArchiveDocument
                                    ndg={ndg}
                                    applicationId={applicationId}
                                    fileDescr={renderHtmlContent(o.label)}
                                    fileId={o.fileDetail[0].id}
                                    updateFn={(val) => updateFn(
                                        val,
                                        [name, i, 'fileDetail', 0, 'documentAttachmentId']
                                    )}
                                    docAttachmentId={o.fileDetail[0].documentAttachmentId}/>
                            </> : null}
                        <Button icon="pi pi-thumbs-up" rounded outlined
                                disabled={shouldDisableFieldFn(name)}
                                severity={!isNil(o.valid) && o.valid ? 'success' : 'secondary'}
                                onClick={() => updateFn(
                                    true,
                                    [name, i, 'valid']
                                )}
                                aria-label={__('Su', 'htr')}/>
                        <Button icon="pi pi-thumbs-down" rounded outlined
                                disabled={shouldDisableFieldFn(name)}
                                severity={!isNil(o.valid) && !o.valid ? 'danger' : 'secondary'}
                                onClick={() => updateFn(
                                    false,
                                    [name, i, 'valid']
                                )}
                                aria-label={__('Giu', 'htr')}/>
                    </div>
                </div>
                {o.fileDetail && o.fileDetail.length > 1
                    ? <ul style={{
                        width: '100%',
                        paddingLeft: '15px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px'
                    }}>
                        {o.fileDetail.map((k, ind) => <li key={k.id} style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            wordWrap: 'anywhere'
                        }}>
                            <span>{k.name}</span>
                            <div className="appPageSection__iconActions">
                                <ArchiveDocument
                                    ndg={ndg}
                                    applicationId={applicationId}
                                    fileId={k.id}
                                    updateFn={(val) => updateFn(
                                        val,
                                        [name, i, 'fileDetail', ind, 'documentAttachmentId']
                                    )}
                                    docAttachmentId={k.documentAttachmentId}/>
                                <Button icon="pi pi-eye" rounded
                                        onClick={() => {
                                            window.open(k.filePath, '_blank').focus()
                                        }}
                                        outlined severity="info"
                                        aria-label={__('Mostra', 'htr')}/>
                            </div>
                        </li>)}
                    </ul>
                    : null}
            </li>) : null}
        </ol>
    )*/
}

export default ListOfFilesToEvaluate;
